import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import { Button, Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import PsychologyWizard from "./PsychologyWizard";
import * as func from "../../common/manipurCommon/FunctionCalls";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import PsychologicalGraph from "./PsychologicalGraph";

const Psychology = () => {

    const [uiSchema, setUiSchema] = useState<any>({});
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pyschologyList, setPsychologyList] = useState<any[]>([]);
    const [detailsList, setDetailsList] = useState<any>(null);
    const [showTable, setShowTable] = useState(false);
    const [viewOpenModal, setViewOpenModal] = useState(false);
    const [searchInput, setSearchInput] = useState("");

    const { permissionsMap } = usePermissions();
    const location = useLocation();
    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    async function newPsychologyAssessment() {
        const injuryResponse = await func.uiPsychologicalSchema();
        setUiSchema(injuryResponse);
        setOpenModal(true);
    }

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            const response = await func.listPyschology();
            setPsychologyList(Array.isArray(response) ? response : [])
            setIsLoading(false);
            setShowTable(true);
        }
        fetchData();
    }, []);

    const filteredData = pyschologyList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const viewDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => viewPsychologyAssessment(rowData)}>
                <i className="feather-eye"></i>View
            </Link>
        );
    };

    async function viewPsychologyAssessment(rowData) {
        const athltId = rowData.athleteId;
        const resumeResponse = await func.viewPsychology(athltId);
        setDetailsList(resumeResponse);
        setViewOpenModal(true)
    }

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const athleteRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    return (

        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Psychology</h4>
                                    <Link
                                        to="#"
                                        className="btn"
                                        onClick={() => { newPsychologyAssessment() }}
                                        data-bs-toggle="tooltip"
                                        style={{ fontSize: "24px", padding: "0px" }}
                                        title="Create Assessment">
                                        <i className="feather-plus" />&nbsp;
                                    </Link>
                                    {/* : null
                                    } */}
                                </div>
                                {showTable && (
                                    <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                )}
                            </div>
                            {showTable && (
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="athleteName"
                                                    header="Athlete Name"
                                                    body={athleteRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {/* {currentPermissions.includes("view") ? */}
                                                <Column
                                                    className="text-link"
                                                    body={viewDetails}
                                                ></Column>
                                                {/* : null
                                                } */}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div >

            <Modal
                show={openModal}
                onHide={() => setOpenModal(false)}
                size="lg"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">Pyschology Assessment</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody style={{ maxHeight: "500px", overflowY: "scroll" }}>
                    <PsychologyWizard data={uiSchema || null} />
                    {/* <p>Psychology Assessment form will be here</p> */}
                </ModalBody>
            </Modal>

            <Modal
                show={viewOpenModal}
                onHide={() => setViewOpenModal(false)}
                size="xl"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">View Psychology Assessment</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setViewOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody style={{ maxHeight: "500px", overflowY: "scroll" }}>
                    <PsychologicalGraph allData={detailsList} />
                </ModalBody>
            </Modal>


        </>
    );
};

export default Psychology;